import PropTypes from 'prop-types';
import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const IconUniPlan = ({ classes = null }) => {
    // misc
    const defaultClasses = ['icon-uniplan'];

    if (classes) {
        defaultClasses.push(classes);
    }

    // render
    return (
        <svg
            className={defaultClasses.join(' ')}
            viewBox='0 0 228 831'
            xmlns='http://www.w3.org/2000/svg'>
            <path
                d='M137.5 505.5h-90v36h180v-36zM181.6 208.3c-2.8-8.5-6.3-13.9-13.7-20.7l-6.7-6.1H180.5v-34h-133v36H88c26.1 0 42.3.4 45.7 1.1 14.9 3.2 21.8 11.8 21.8 27.1 0 12.6-6.3 19.8-19.8 22.7-3.4.7-19.9 1.1-46.7 1.1H47.5v36.1l49.8-.4c53.9-.4 55-.5 66.4-6.3 9.4-4.8 16.2-14.3 18.7-26.2 1.7-8.2 1.3-23.7-.8-30.4ZM181.9 413.5c-2.4-9-9.3-19-15.5-22.7-1.6-1-2.9-2.1-2.9-2.5 0-.4 3.8-.8 8.5-.8h8.5v-34H.5v36h64.4l-5.5 4.9c-6 5.4-11.3 14.1-13.5 22.5-1.8 6.8-1.8 20.8.1 27.9 8.6 33.1 47.6 50.7 90.3 40.7 13.1-3.1 22.4-8.2 31.3-17 8-8 11.7-14.2 14.4-24.6 1.9-7.3 1.8-23.1-.1-30.4Zm-28.2 20.7c-6.1 11.9-24.5 19.3-44.8 18-16.5-1.1-28.5-6.9-34.1-16.4-2.6-4.4-2.8-5.6-2.8-15.4 0-10 .2-10.8 3-15.4 3.7-6 9.5-10.6 17.2-13.6 7.9-3 27.7-3.8 37.6-1.5 15.9 3.7 25 12.3 26.6 25.1.9 6.7-.2 14.3-2.7 19.2ZM182.5 607.3c-.5-2.5-1.6-7.3-2.5-10.5-5.2-17.9-19-31.2-34.4-33l-5.1-.6.2 17.8.3 17.8 4.7 1.4c9.5 2.7 14.3 11 14.2 24.3-.1 13.8-4.6 21.2-13.8 22.5-5.9.9-9.4 0-12.9-3.3-3.7-3.5-5.2-9.2-8.1-30.4-3.8-26.9-6.5-35.3-14.3-43.9-12.9-14.2-41.8-14-55.1.5-7.9 8.5-11.2 18.8-11.2 34.6 0 16.5 4.6 31.1 12.4 39.7 3.7 4.1 3.7 5.3.2 5.3-1.2 0-3.8.5-5.8 1.1l-3.8 1v18.1c0 16.8.1 18 1.8 17.3 7.5-3 15.8-3.5 57.7-3.5 35.1 0 44.1-.3 48.9-1.5 18.8-4.9 27.8-23.3 27.5-56.4-.1-7.5-.5-15.7-.9-18.3Zm-79.9 40.2c-14.1 0-21.5-2.4-27.4-9-5.4-5.9-7.2-11.7-7-22.2.1-10.4 2.9-16.4 9.3-19.5 5-2.6 7.7-2.8 13.5-1.2 8.8 2.5 12.8 10.6 16 32.4.9 6.1 2.5 12.6 3.5 14.5 1 1.9 1.8 3.8 1.9 4.3.1.4-4.4.7-9.8.7ZM181.2 766.3c-3-8.6-8.8-17.1-14.9-21.6-2.6-2-4.5-3.9-4.2-4.4.3-.4 4.5-.8 9.5-.8h8.9v-34h-133v35.8l41.8.4c38.8.4 42.1.6 47.9 2.5 12.5 4.2 17.4 10.5 18.1 23.4.8 13.4-3.8 20.8-15 24.6-4.6 1.5-10.8 1.7-49 2.1l-43.8.3v36.1l48.8-.4c45.7-.4 49.2-.6 56.4-2.6 9.6-2.6 12.9-4.3 18.5-9.5 8.4-7.7 12.3-19 12.3-35.2 0-7.8-.6-11.5-2.3-16.7ZM131.8.7c-45.8.4-49.3.6-56.5 2.6-9.6 2.6-12.9 4.3-18.5 9.5-8.3 7.6-12.3 19-12.3 34.8 0 16.4 6.3 30.6 17.1 38.7 2.6 1.9 4.6 3.9 4.3 4.4-.3.4-4.5.8-9.5.8h-8.9v34h133V89.7l-41.7-.4c-40.1-.4-42.1-.5-48.6-2.7-12-3.9-17.7-12.3-17.7-26 .1-11.5 4.9-18.3 15.3-21.8 4.5-1.5 10.9-1.7 49-2.1l43.7-.3V.3l-48.7.4ZM114 294.5H47.5v36h133v-36z'
                fill='currentColor' />
        </svg>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

const propTypes = {
    classes: PropTypes.string
};

IconUniPlan.propTypes = propTypes;

export { IconUniPlan };

export default IconUniPlan;
